import { Container, Title, Text, Button, Stack, Box, rem } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router';

export function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <Container size="sm" py="xl">
      <Stack align="center" gap="lg">
        <Box
          style={{
            width: 80,
            height: 80,
            borderRadius: rem(8),
            background: 'var(--mantine-color-vdzGray-7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconLock size={40} color="white" stroke={1.5} />
        </Box>

        <Stack align="center" gap="xs">
          <Title order={1} ta="center">
            403 - Zugriff verweigert
          </Title>
          <Text c="vdzGray.6" ta="center" maw={400}>
            Sie haben keine Berechtigung, auf diese Seite zuzugreifen.
            Bitte wenden Sie sich an Ihren Administrator, wenn Sie glauben,
            dass dies ein Fehler ist.
          </Text>
        </Stack>

        <Button
          variant="light"
          onClick={() => navigate('/dashboard')}
          mt="md"
        >
          Zurück zum Dashboard
        </Button>
      </Stack>
    </Container>
  );
}
